export default {"src":"/uk/_next/static/media/healthcareIcon.e9a153f3.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};